module.exports = __webpack_public_path__ + "static/media/upload-icon.b11b4ac9.svg";